import { latestItems } from "@/mocks/portal";

export default function LatestSection() {
  return (
    <section id="latest" className="w-full bg-background-50 py-14 md:py-20">
      <div className="max-w-content mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 md:gap-12">
          <div className="lg:col-span-1">
            <span className="inline-flex items-center gap-1.5 text-xs md:text-sm font-medium text-primary-600">
              <i className="ri-history-line"></i>
              最新更新
            </span>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              新料按时间倒序，随时刷新
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              热点与娱乐分区保持每日多次更新，其余分区按各自节奏跟进。下面是最新一批整理完成的内容。
            </p>
            <div className="mt-6 rounded-card border border-accent-200 bg-accent-50 p-4 md:p-5">
              <p className="text-sm text-accent-900 leading-relaxed">
                <i className="ri-lightbulb-line mr-1.5"></i>
                想更快找到新料？用首屏搜索框输入关键词，结果会实时匹配标题、摘要与分区。
              </p>
            </div>
          </div>

          <div className="lg:col-span-2">
            <ol className="relative border-l border-background-300 ml-1.5">
              {latestItems.map((item) => (
                <li key={item.id} className="relative pl-6 pb-6 last:pb-0">
                  <span className="absolute -left-[5px] top-1.5 w-2.5 h-2.5 rounded-full bg-primary-500 ring-4 ring-background-50"></span>
                  <div className="flex flex-wrap items-center gap-2 text-[11px] md:text-xs text-foreground-500">
                    <span className="inline-flex items-center gap-1 font-medium text-foreground-700">
                      <i className="ri-calendar-line"></i>
                      {item.date}
                    </span>
                    <span>{item.time}</span>
                    <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-secondary-800">
                      {item.category}
                    </span>
                  </div>
                  <a
                    href="#category"
                    className="mt-1.5 block font-heading text-base md:text-lg font-bold text-foreground-950 leading-snug cursor-pointer transition-colors hover:text-primary-600"
                  >
                    {item.title}
                  </a>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}